import { getTypography } from '@creditas-ui/utilities';
import { styled, css, keyframes } from '@creditas-ui/system';

export const Logout = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  margin-left: 8px;
`;

export const UserLoggoutButton = styled.button`
  border: none;
  background: transparent;
  ${getTypography('bodyMdLight')}
  cursor: pointer;
  font-weight: 400;
  color: #39ad71;
`;
